/// <reference path="../../app.d.ts"/>
import { AppUtils } from '../../../../../shared/utils/index';


import { FeedbackFormModel } from "../models/FeedbackFormModel";
import { BasicApplicationUrlBuilder } from "../../../../../shared/services/BasicApplicationUrlBuilder";
import { GasStationModel } from "../models/GasStationModel";
import { GasStationResponseApi } from "../models/GasStationResponseApi";
import { ModelAdapter } from "../models/ModelAdapter";
import { CorrectionResponseApi } from "../models/CorrectionResponseApi";

export class AppApiService {
	private readonly options: BasicAppOptions<FuelPricesUserFeedbackAppDefinition>;
	private readonly applicationUrlBuilder: BasicApplicationUrlBuilder<FuelPricesUserFeedbackAppDefinition>;

	constructor(options: BasicAppOptions<FuelPricesUserFeedbackAppDefinition>) {
		this.options = options;
		this.applicationUrlBuilder = new BasicApplicationUrlBuilder(this.options);
	}

	public retrieveGasStation(gasStationID: string, successCallback: (gasStationModel: GasStationModel) => void, errorCallback: (jqxhr?: JQuery.jqXHR, textStatus?: JQuery.Ajax.ErrorTextStatus, errorThrown?: string) => void): void {
		if (gasStationID) {
			const req = {
				method: 'GET',
				url: this.applicationUrlBuilder.fullApimUrl(AppUtils.Url.combine(this.options.app.apigasstationdetail, gasStationID)),
				headers: { "Ocp-Apim-Subscription-Key": T.Utils.Application.apimSubscriptionKey }
			};
			AppUtils.Ajax.fragment(req, (data: ApiResponse<GasStationResponseApi>) => {
				if (data.Data && data.Success) {
					successCallback(ModelAdapter.getGasStationModel(data.Data));
				} else {
					errorCallback(undefined, "error", "APIM error");
				}
			}, errorCallback);
		} else {
			errorCallback(undefined, "error", "No gasStationID specified");
		}
	}

	public submitPriceCorrection(formModel: FeedbackFormModel, verificationToken: string,
		successCallback: (data: CorrectionResponseApi, textStatus?: string, jqxhr?: JQuery.jqXHR) => void, errorCallback: (jqxhr?: JQuery.jqXHR, textStatus?: JQuery.Ajax.ErrorTextStatus, errorThrown?: string) => void): void {

		const reqData = ModelAdapter.getPriceCorrectionRequestApi(formModel).toRequestObject();
		reqData.Token = verificationToken;
		const req: JQuery.AjaxSettings = {
			method: 'POST',
			// local API, do not append any host
			url: this.options.app.apipricecorrection,
			data: JSON.stringify(reqData)
		};

		AppUtils.Ajax.fragment(req, successCallback, errorCallback);
	}

	public submitGasStationCorrection(formModel: FeedbackFormModel, verificationToken: string,
		successCallback: (data: CorrectionResponseApi, textStatus?: string, jqxhr?: JQuery.jqXHR) => void, errorCallback: (jqxhr?: JQuery.jqXHR, textStatus?: JQuery.Ajax.ErrorTextStatus, errorThrown?: string) => void): void {

		const reqData = ModelAdapter.getGasStationCorrectionRequestApi(formModel).toRequestObject();
		reqData.Token = verificationToken;
		const req: JQuery.AjaxSettings = {
			method: 'POST',
			// local API, do not append any host
			url: this.options.app.apigasstationcorrection,
			data: JSON.stringify(reqData)
		};

		AppUtils.Ajax.fragment(req, successCallback, errorCallback);
	}

}
